import React, { useEffect, useState } from 'react'
import Header from '../../Layout/Header';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer } from "recharts";
import MotivationChart from './MotivationChart';
import PersistanceChart from './PersistanceChart';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { useWindowSize } from 'react-use'
import Confetti from 'react-confetti'

export default function AuctionDetails() {

    const { width, height } = useWindowSize()

    const data = [
        { subject: "Muscle Strength", value: 90 },
        { subject: "Knee Strength", value: 75 },
        { subject: "Transversal Physiological", value: 80 },
        { subject: "Quadriceps Muscle Strength", value: 85 },
        { subject: "Hand Grip Strength", value: 70 },
        { subject: "Biceps Increase", value: 65 },
        { subject: "Prone to Injury", value: 50 },
    ]

    const [isPurchase, setPurchase] = useState(false);

    const handlePurchase = () => {
        setPurchase(!isPurchase)
    }

    const [hideTicks, setHideTicks] = useState(window.innerWidth < 1024);

    useEffect(() => {
        const handleResize = () => {
            setHideTicks(window.innerWidth < 1050);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className='min-h-screen bg-cover text-white' style={{ backgroundImage: 'url("/assets/bg/Fundbg.svg")' }}>
            <div className='h-[90px]'><Header /></div>
            <div className='w-[90%] mx-auto pb-10'>
                <h1 className='text-center font-bold text-xl lg:text-2xl 2xl:text-3xl uppercase'>Auction pool</h1>
                <div className='bg-white/10 rounded-xl p-10 mt-5 flex flex-col lg:flex-row gap-10'>
                    <div className='w-[100%] lg:w-[45%] relative'>
                        <div className='flex justify-center'>
                            <h1 className='text-3xl md:text-5xl lg:text-6xl 2xl:text-7xl text-transparent bg-clip-text bg-gradient-to-r from-[#FF6F00] to-[#E6CF8E] font-extrabold'>Player 1</h1>
                        </div>
                        <img src='/assets/others/Goat.svg' className='lg:absolute lg:w-[65%] 2xl:w-[50%] mx-auto lg:translate-x-[50%] lg:right-[50%]'></img>
                    </div>
                    <div className='w-[100%] lg:w-[55%]'>
                        <div className='flex justify-between flex-wrap'>
                            <div className='flex gap-3 flex-wrap'>
                                <div className='text-black bg-[#D9D9D9]/55 py-1.5 px-7 rounded-xl font-bold'>
                                    Iranian
                                </div>
                                <div className='text-black bg-[#D9D9D9]/55 py-1.5 px-7 rounded-xl font-bold'>
                                    Left Foot
                                </div>
                                <div className='text-black bg-[#D9D9D9]/55 py-1.5 px-7 rounded-xl font-bold'>
                                    FWR
                                </div>
                            </div>
                            <div className='font-bold text-[#29E90F] text-xl'>
                                186 Ft
                            </div>
                        </div>
                        <p className='mt-4'>NFTs are a new form of digital ownership, unlocking endless possibilities for creators and collectors alike. NFTs are a new form of digital ownership, unlocking endless possibilities for creators and collectors alike.</p>
                        <div className='flex flex-col lg:flex-row gap-3 items-center justify-between mt-4'>
                            <div className='text-center lg:text-left'>
                                <h1 className='font-bold text-3xl'>200 GDX</h1>
                                <h2 className='font-semibold mt-3 italic'>Bidding ends on 1:09:23 hrs</h2>
                            </div>
                            <div className='flex flex-col gap-3'>
                                <button className='bg-[#5C1FE2] rounded-lg py-1.5 px-7 uppercase font-bold cursor-pointer'>Place a bid</button>
                                <button className='bg-[#303737] rounded-lg py-1.5 px-7 font-bold cursor-pointer' onClick={handlePurchase}>Buy Now</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='w-[100%] lg:w-[60%] ml-auto bg-white/10 my-5 p-5 rounded-xl grid grid-cols-1 lg:grid-cols-2 gap-3'>
                    <div className='flex gap-3 items-center justify-center'>
                        <img src='/assets/icon/SoccerBall.svg'></img>
                        <h1 className='text-[#7D7D7D] font-bold w-[40%]'>Goals</h1>
                        <p className='font-bold'>23</p>
                    </div>
                    <div className='flex gap-3 items-center justify-center'>
                        <img src='/assets/icon/Tackle.svg'></img>
                        <h1 className='text-[#7D7D7D] font-bold w-[40%]'>Tackle</h1>
                        <p className='font-bold'>23</p>
                    </div>
                    <div className='flex gap-3 items-center justify-center'>
                        <img src='/assets/icon/Soccer Player.svg'></img>
                        <h1 className='text-[#7D7D7D] font-bold w-[40%]'>Assist</h1>
                        <p className='font-bold'>23</p>
                    </div>
                    <div className='flex gap-3 items-center justify-center'>
                        <img src='/assets/icon/Goalkeeper.svg'></img>
                        <h1 className='text-[#7D7D7D] font-bold w-[40%]'>Goal saves</h1>
                        <p className='font-bold'>23</p>
                    </div>
                </div>
                <div className='flex flex-col lg:flex-row gap-5'>
                    <div className='w-[100%] lg:w-[65%] bg-white/10 rounded-xl'>
                        <ResponsiveContainer width="100%" height={400}>
                            <RadarChart outerRadius={120} data={data} >
                                <PolarGrid />
                                <PolarAngleAxis dataKey="subject" stroke='white'  tickSize={15} tick={!hideTicks} />
                                <PolarRadiusAxis angle={30} domain={[0, 100]} />
                                <Radar name="Athlete Stats" dataKey="value" stroke="#5C1FE2" fill="#5C1FE2" fillOpacity={0.6} />
                            </RadarChart>
                        </ResponsiveContainer>
                        <div className='block lg:hidden'>
                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 mt-5 w-full px-4">
                                {data.map((item, index) => (
                                    <div key={index} className="p-2 text-center text-white rounded-md bg-[#A51FFF]/50">
                                        {item.subject}: <span className="font-bold">{item.value}%</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className='w-[100%] lg:w-[35%] bg-white/10 rounded-xl p-5 grid content-around'>
                        <div><MotivationChart /></div>
                        <div><PersistanceChart /></div>
                        <h1 className='font-bold text-center'>Physical Attributes</h1>
                    </div>
                </div>
            </div>
            {isPurchase && (
                <div className="fixed inset-0 flex items-center h-full justify-center bg-[#000]/95 z-50  px-2 py-5 overflow-hidden">
                    <Confetti width={width} height={height} />
                    <div className='absolute top-7 right-7' ><FontAwesomeIcon className='cursor-pointer' onClick={handlePurchase} icon={faXmark} /></div>
                    <div className='w-[100%] lg:w-[40%] text-center' style={{ fontFamily: "Barlow" }}>
                        <h1 className='font-bold text-xl uppercase'>Congratulations</h1>
                        <p className='my-4'>The NFT successfully purchased</p>
                        <img src='/assets/others/player.svg' style={{ zIndex: 50 }} className='mx-auto'></img>
                    </div>
                </div>
            )}
        </div>
    )
}
